export default __webpack_public_path__ + "./img/general_purpose.png";